<div class="ml-4 w-full flex items-start">
  <div>
    @if (subTitle && subTitle !== Header && breadcrumbs.length === 1 && isSubTitle) {
    <p class="text-base text-primary mt-1">
      {{ subTitle }}
    </p>
    } @if (breadcrumbs.length > 1 || !isSubTitle) {
    <nav aria-label="breadcrumb" class="w-full">
      <ol class="flex flex-wrap items-center text-base text-neutral-light">
        @if (start.length > 0) { @for (item of start; track item.label; let index = $index) {
        <li class="flex items-center">
          @if (index !== start.length - 1) {
          <a
            class="flex items-center text-md text-ignyte-theme px-0.5 py-1 arrow-bottom1"
            [routerLink]="item.url"
            tabindex="0"
          >
            {{ item.label }}
            <span class="text-neutral-light ml-2 mr-1">
              <lib-icon
                class="mt-1 text-md"
                [icon]="
                  start.length > 2 ? BreadcrumIcon.Right_Arrow_Dashed : BreadcrumIcon.Right_Arrow
                "
                [category]="AssetsCategory.Breadcrumb"
              ></lib-icon>
            </span>
          </a>
          } @else { @if (collapsed.length === 0) {
          <span
            class="px-0.5 text-md py-1 rounded text-neutral-light"
            [ngClass]="{ 'text-gray-500': start.length > 2 }"
            >{{ item.label }}</span
          >
          } }
        </li>
        } } @if (collapsed.length > 0) {
        <li class="relative group flex items-center">
          <a
            tabindex="0"
            class="flex items-center px-2 py-1 hover:bg-primary-lightest rounded focus:outline-none focus:ring-2 focus:ring-blue-300"
          >
            ...
            <lib-icon
              class="ml-1 w-2 h-3 stroke-gray-300"
              [icon]="BreadcrumIcon.Right_Arrow"
              [category]="AssetsCategory.Breadcrumb"
            ></lib-icon>
          </a>
          <ul
            class="absolute left-0 top-full mt-4 hidden group-hover:block group-focus-within:block bg-white border border-neutral-lighter rounded-lg shadow-xl z-10 min-w-max"
          >
            <div class="absolute left-1/2 -top-[11px] left-[15%] z-20">
              <div
                class="w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-b-[10px] border-b-gray-300 relative"
              >
                <div
                  class="absolute top-[1px] left-[-10px] w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-b-[10px] border-b-white"
                ></div>
              </div>
            </div>
            @for (item of collapsed; track item.label + $index) {
            <li>
              <a
                [routerLink]="item.url"
                class="block px-4 py-2 text-neutral-light hover:bg-primary-lightest hover:text-black whitespace-nowrap hover:bg-primary-lightest rounded focus:outline-none focus:ring-2 focus:ring-blue-300"
              >
                {{ item.label }}
              </a>
            </li>
            }
          </ul>
        </li>
        } @if (end.length > 0) { @for (item of end; track item.label; let index = $index) {
        <li class="flex items-center">
          @if (index !== end.length - 1) {
          <a
            [routerLink]="item.url"
            class="flex items-center px-2 py-1 color-primary rounded hover:text-primary"
          >
            {{ item.label }}
            <lib-icon
              class="ml-1 w-2 h-3 stroke-gray-300"
              [icon]="BreadcrumIcon.Right_Arrow"
              [category]="AssetsCategory.Breadcrumb"
            ></lib-icon>
          </a>
          } @else {
          <span class="px-2 py-1 rounded text-neutral-light">{{ item.label }}</span>
          }
        </li>
        } }
      </ol>
    </nav>
    }
  </div>
</div>
